<template>
	<div class="content">
		<Breadcrumb  bgcolor="#fff"></Breadcrumb>
		<div class="user-content">
			<div class="content-left">
				<UserMenu></UserMenu>
			</div>
			<div class="content-right">
				<router-view></router-view>
			</div>
		</div>

	</div>

</template>

<script>
	import UserMenu from "@/components/UserMenu.vue"
	import Breadcrumb from "@/components/Breadcrumb.vue";
	export default {
		name: 'UserLayout',
		components: {
			UserMenu,
			Breadcrumb
		},
		data() {
			return {
			};
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>

	.content {
		padding-bottom: 60px;
		background: #F3F4F5;
		padding-top: 20px;
		.user-content{
			width: 1170px;
			margin: 20px auto;
			display: flex;
			.content-right{
				width: 950px;
				margin-left: 20px;
			}
		}
	}
</style>
